import styled from 'styled-components';

import { InputNew, Select, theme } from 'components';

export const StyledInput = styled(InputNew)`
  background-color: ${theme.white};
  border: 1px solid ${theme.gray5};
  border-radius: ${theme.getBorderRadius('small')};
`;

export const StyledPasswordInput = styled(InputNew.Password)`
  background-color: ${theme.white};
  border: 1px solid ${theme.gray5};
  border-radius: ${theme.getBorderRadius('small')};
  & > input {
    background-color: inherit;
  }
`;

export const StyledSelect = styled(Select)`
  & > .ant-select > .ant-select-selector {
    background-color: ${theme.white};
    border: 1px solid ${theme.gray5};
    border-radius: ${theme.getBorderRadius('small')};
  }
`;
